/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React from 'react';

import {
  VideoContainer,
  VideoContent,
  VideoContentText,
  VideoContentType,
  VideoProgressIndicator,
  VideoProgressIndicatorIn,
} from './styled';

import { withFocusable } from '@noriginmedia/react-spatial-navigation';
import { Load } from '../../ui/styled';

export default withFocusable({})(function VideoButton({
  item,
  spaced,
  focused,
  onPress,
  loading,
}: {
  item?: {
    cover?: unknown;
    preview?: { uri?: string };
    title?: string;
    contentType?: string;
  };
  spaced?: boolean;
  focused?: boolean;
  onPress?: () => void;
  loading?: boolean;
}) {
  return (
    <>
      <VideoContainer onPress={onPress} spaced={spaced}>
        <VideoContent
          source={focused && item?.preview?.uri ? item.preview : item?.cover}
          focused={focused}
          loading={loading}
        >
          {loading ? <Load flat /> : null}
          {/* {
                        focused ? 
                            <VideoProgressIndicator>
                                <VideoProgressIndicatorIn />
                            </VideoProgressIndicator>
                        : null
                    } */}
        </VideoContent>
        <VideoContentText>{item?.title}</VideoContentText>
        {item?.contentType ? <VideoContentType>{item.contentType}</VideoContentType> : null}
      </VideoContainer>
    </>
  );
});
